import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const LoginFooter = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = [
    {
      label: 'API Documentation',
      href: '/api-documentation-hub',
      icon: 'BookOpen'
    },
    {
      label: 'Support',
      href: '#',
      icon: 'HelpCircle'
    },
    {
      label: 'Privacy Policy',
      href: '#',
      icon: 'Shield'
    },
    {
      label: 'Terms of Service',
      href: '#',
      icon: 'FileText'
    }
  ];

  return (
    <footer className="mt-12 pt-8 border-t border-border">
      {/* Quick Links */}
      {/* <div className="grid grid-cols-2 gap-4 mb-6">
        {footerLinks?.map((link) => (
          <Link
            key={link?.label}
            to={link?.href}
            className="flex items-center space-x-2 p-2 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-smooth"
          >
            <Icon name={link?.icon} size={14} />
            <span>{link?.label}</span>
          </Link>
        ))}
      </div> */}
      {/* Company Info */}
      <div className="text-center space-y-3">
        {/* <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Globe" size={12} />
            <span>Global API Access</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Clock" size={12} />
            <span>24/7 Support</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Zap" size={12} />
            <span>99.9% Uptime</span>
          </div>
        </div> */}

        <div className="text-xs text-muted-foreground">
          <p>&copy; {currentYear} LakeeeShop. All rights reserved.</p>
          <p className="mt-1">Secure API documentation and management platform</p>
        </div>
      </div>
      {/* Status Indicator */}
      <div className="flex items-center justify-center mt-4 pt-4 border-t border-border">
        <div className="flex items-center space-x-2">
          {/* <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-xs text-muted-foreground">All systems operational</span> */}
        </div>
      </div>
    </footer>
  );
};

export default LoginFooter;